if (document.querySelector('[name="csrf-token"]') ) {
  window.csrfToken = (document.querySelector('[name="csrf-token"]') as HTMLMetaElement).content;
}
